import script from "./XTitleLabel.vue?vue&type=script&lang=ts&setup=true"
export * from "./XTitleLabel.vue?vue&type=script&lang=ts&setup=true"

import "./XTitleLabel.vue?vue&type=style&index=0&id=4e6dd09b&lang=css&scoped=true"

import exportComponent from "/Users/nicholas/Documents/Work/Workspace/x1/hotelOS/vue3-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e6dd09b"]])

export default __exports__